import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import { useIntl } from '@/intl'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import styles from './Banner.module.css'

export enum BannerCampaigns {
  Countdown = 'countdown',
  Urgency = 'urgency',
}

interface BannerProps extends React.PropsWithChildren {
  campaign?: BannerCampaigns
  endDate?: string
}

export default function Banner({ children, campaign = BannerCampaigns.Urgency, endDate }: BannerProps) {
  const intl = useIntl()
  const { rephraseDiscounts } = useOptimizelyFlagContext()

  return (
    <div className={cn(styles.wrapper, campaign === BannerCampaigns.Countdown && styles.countdown)}>
      {campaign === BannerCampaigns.Countdown
        ? (
            <div className={styles.countdownWrapper}>
              <Typography variant="body-m-bold-tight">
                {children}
              </Typography>
              <Typography>{endDate}</Typography>
            </div>
          )
        : (
            <div className={styles.urgencyWrapper}>
              {rephraseDiscounts
                ? (
                    <Typography variant="body-m-bold-tight">
                      {intl.formatMessage({ id: 'prices_emergency_banner_rephrase_discounts_text' })}
                    </Typography>
                  )
                : (
                    <>
                      <Typography variant="body-m-bold-tight">
                        {intl.formatMessage({ id: 'prices_emergency_banner_strong_text' })}
                      </Typography>
                      <Typography>
                        {intl.formatMessage({ id: 'prices_emergency_banner_text' })}
                      </Typography>
                    </>
                  )}
            </div>
          )}
    </div>
  )
}
